import { z } from "zod";

export const ProviderName = z.enum(["hetzner"]);
export type ProviderName = z.infer<typeof ProviderName>;

export const Connection = z.object({
  provider: ProviderName,
  permission: z.enum(["read", "read_write"]),
  status: z.enum(["active", "failing", "revoked"]),
  /** Last four characters of the credential, so users can tell tokens apart. */
  credentialHint: z.string(),
  lastSyncAt: z.iso.datetime().nullable(),
  lastError: z.string().nullable(),
});
export type Connection = z.infer<typeof Connection>;

/**
 * What the caller may do in a project they can see: `admin` (organisation
 * administrator), `owner` (full rights inside it) or `guest` (view only).
 */
export const ProjectAccess = z.enum(["guest", "owner", "admin"]);
export type ProjectAccess = z.infer<typeof ProjectAccess>;

export const Project = z.object({
  id: z.uuid(),
  name: z.string(),
  createdAt: z.iso.datetime(),
  connection: Connection.nullable(),
  access: ProjectAccess,
});
export type Project = z.infer<typeof Project>;

const ProjectName = z.string().trim().min(1).max(64);
/** Hetzner tokens are 64 characters; the bounds leave room for other providers. */
const Credential = z.string().trim().min(16).max(512);

export const CreateProjectRequest = z.object({
  name: ProjectName,
  provider: ProviderName,
  credential: Credential,
});
export type CreateProjectRequest = z.infer<typeof CreateProjectRequest>;

export const UpdateProjectRequest = z.object({ name: ProjectName });
export type UpdateProjectRequest = z.infer<typeof UpdateProjectRequest>;

export const ReplaceCredentialRequest = z.object({ credential: Credential });
export type ReplaceCredentialRequest = z.infer<typeof ReplaceCredentialRequest>;
